<template>
  <b-card>
    <b-overlay
      variant="white"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
      :show="loadingState"
    >
      <quiz-list-component @questions-loading-state="loadingState = $event" />
    </b-overlay>
  </b-card>
</template>

<script>
import { BOverlay, BCard } from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import QuizListComponent from '../components/QuizList.vue'

export default {
  components: {
    QuizListComponent,
    BOverlay,
    BCard,
  },
  setup() {
    const loadingState = ref(true)
    return {
      loadingState,
    }
  },
}
</script>
